module.exports = __webpack_public_path__ + "img/94ddf20.jpeg";